
<div class="row card-deck">
  <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form">

    <div class="card-header wh-header">
       Profile Picture
      <button type="button" class="close" data-dismiss="modal"
              (click)="activeModal.dismiss('Cross click')"
              aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">


      <form novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">

        <div class="form-group">
          <div class="col-md-12">
            <input type="file" class="form-control" (change)="fileChange($event)"
                   name="UploadActorImage" id="UploadActorImage" accept="image/*"
                   [(ngModel)]="UploadActorImage" placeholder="Upload">
          </div>
        </div>
        <div class="modal-footer">
          
            <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn btn-primary modal-button-center upload-button">Upload</button>


         
        </div>

      </form>
    </div>


    <!--<div class="modal-footer">
      <button type="button" class="btn btn-secondary btn-raised" (click)="activeModal.close('Close click')">Close</button>
    </div>-->
  </div>
  </div>
